import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect, reducers } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Urls } from 'kts-platform-frame/entry/constant';
import { Card, Button, Icon, Input, Select, Row, Col, Tabs, Pagination  } from 'antd';
import BillTable from './UI.BillTable';
import SearchDetail from './UI.SearchDetail';
import MyStore from 'kts-platform-frame/redux/MyStore';
import SelectBillTypeM from './UI.SelectBillTypeM';
import RefuseM from './UI.RefuseM';

const Option = Select.Option;
const TabPane = Tabs.TabPane;

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    loadingUrls?: Map<Urls, string>;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    loadingUrls: state.system.loadingUrls,
}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    render() {
        const { loadingUrls } = this.props;
        const tabBarExtraContent = <a href="#">视图管理</a>;
        return (
            <div className={css.billList}>
                    <div className={css.title}>
                        单据
                    </div>
                    <Row className={css.listHeader}>
                        <Col span={12}>
                            <div className={css.headerLeft}>
                                <Button className='kts-but-primary' onClick={() => ModulesAction.changeBillTypeM()} style={{ marginRight: '13px' }}><Icon type="xinzeng" />新建单据</Button>
                                <Input 
                                    value={this.modulesState.keyword} 
                                    placeholder="输入公司名称或编号" 
                                    className={css.inputSearch}
                                    onChange={ModulesAction.bindKeyword}
                                />
                            <Button onClick={ModulesAction.searchDate} className='kts-but-default'><Icon type="search" />搜索</Button>
                            </div>
                        </Col>
                        <Col span={12}>
                            <div className={css.headerRight}>
                                {/* <Select defaultValue="1" className={css.selectBt} >
                                    <Option value="1">最近三天的已拒订单</Option>
                                    <Option value="lucy">已发送的订单</Option>
                                </Select> */}
                                <Button className={`${css.filterBt} kts-but-default`} onClick={this.onShowPanel}><Icon type="filter" />筛选</Button>
                                <Button className='kts-but-default' onClick={() => ModulesAction.getData()}><Icon type="sync" /></Button>
                            </div>
                        </Col>
                    </Row>
                    <div className={css.cardContainer}>
                        <Tabs type="editable-card" hideAdd={true}>
                        {/* <Tabs type="editable-card" hideAdd={true} tabBarExtraContent={tabBarExtraContent}> */}
                        <TabPane tab="全部" key="1" closable={false}/>
                            {/* <TabPane tab="详dsdwew情" key="2" closable={true}/> */}
                            {/* <TabPane tab="详情" key="2" />
                            <TabPane tab="详情2" key="3" /> */}
                        </Tabs>
                    </div>
                    <BillTable/>
                    <div className={css.pagins}>
                        <Pagination 
                            showSizeChanger={true} 
                            size="small" 
                            showQuickJumper={true} 
                            defaultCurrent={this.modulesState.pageNum}
                            current={this.modulesState.pageNum}
                            total={this.modulesState.total}
                            onChange={ModulesAction.pageSet}
                            onShowSizeChange={ModulesAction.pageSet}
                            pageSize={this.modulesState.pageSize} 
                            showTotal={this.showTotal}
                        />
                    </div>
                <SelectBillTypeM/>
                {this.modulesState.refuseM && <RefuseM/>}
            </div>
        );
    }
    /**
     * show总条数
     */
    private showTotal = (total: number) => {
        return `共 ${total} 条`;
    }
    /**
     * 侧边栏搜索
     */
    private onShowPanel = () => {
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
            Components: <SearchDetail />,
            title: '筛选'
        });
        // MyStore.instance.dispatch(reducers.aside.ActionTypes.show, {
        //     Components: <SearchDetail />,
        //     title: '筛选'
        // });
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/DocumentList/UI.BillList.tsx